import React from "react";
import { BsEnvelope, BsTelephone, BsHeart, BsSearch } from "react-icons/bs";
import { TfiAngleDown } from "react-icons/tfi";
import { RxAvatar } from "react-icons/rx";
import { CiShoppingCart } from "react-icons/ci";
import { Link } from "react-router-dom";

const headerRight = [
  {
    id: 1,
    text: "English",
    icon: TfiAngleDown,
  },
  {
    id: 2,
    text: "USD",
    icon: TfiAngleDown,
  },
  {
    id: 3,
    text: "Login",
    icon: RxAvatar,
    url: "login",
  },
  {
    id: 4,
    text: "Wishlist",
    icon: BsHeart,
  },
  {
    id: 5,
    text: "",
    icon: CiShoppingCart,
  },
];

const navigation = [
  {
    id: 1,
    text: "Home",
    url: "/",
  },
  {
    id: 5,
    text: "Shop",
    subItems: [
      {
        id: 1,
        text: "Shop Grid",
        url: "shopgrid",
      },
      {
        id: 2,
        text: "Shop List",
        url: "shoplist",
      },
      {
        id: 3,
        text: "Shop Sidebar",
        url: "shopsidebar",
      },
    ],
  },
  {
    id: 2,
    text: "Pages",
    subItems: [
      {
        id: 1,
        text: "Demo",
        url: "demo",
      },
    ],
  },
  {
    id: 3,
    text: "Shopping Cart",
    url: "shoppingcart",
  },
  {
    id: 4,
    text: "Blog",
    url: "blog",
  },
  {
    id: 6,
    text: "Contact",
    url: "contact",
  },
  {
    id: 7,
    text: "About",
    url: "about",
  },
];

export default function header() {
  return (
    <header>
      <div className=" font-fontOne bg-violet text-white py-2">
        <div className="flex justify-between mx-auto max-w-5xl text-sm">
          {/* left side */}
          <div className="flex">
            <div className="flex items-center">
              <BsEnvelope />
              <p className="ml-3 mr-8">example@email.com</p>
            </div>
            <div className="flex items-center">
              <BsTelephone />
              <p className="ml-3">+968 75323 32 243 2</p>
            </div>
          </div>
          {/* right side */}
          <div className="flex">
            {headerRight.map((value) => {
              return (
                <Link
                  to={value.url ? value.url : null}
                  className="flex items-center ml-4 hover:text-gray-200"
                  key={value.id}
                >
                  {value.text}
                  <value.icon
                    size={value.text === "" ? 20 : null}
                    className=" ml-1 -translate-y-[1px]"
                  />
                </Link>
              );
            })}
          </div>
        </div>
      </div>
      <div className=" bg-white">
        <div className=" max-w-5xl mx-auto flex justify-between md:flex-row flex-col">
          {/* left side */}
          <div className="flex items-center py-4">
            {/* logo */}
            <h1 className=" text-3xl font-fontOne font-bold mr-16">Hekto</h1>
            {/* navigation */}
            <nav className="flex text-sm">
              {navigation.map((value) => (
                <NavElement key={value.id} data={value} />
              ))}
            </nav>
          </div>
          {/* right side */}
          <div className=" flex items-center ">
            {/* search */}
            <div className="flex border-1 border-gray-700 ">
              <input
                type="text"
                className=" border-2 border-r-0 border-gray-200 pl-1 active:outline-0 focus:outline-0"
              />
              <button className="bg-pink py-2 px-3 text-white">
                <BsSearch />
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

function NavElement({ data }) {
  return data.subItems ? (
    <div className="group">
      <div key={data.id} className="mr-6 cursor-pointer hover:text-pink">
        {data.text}
        <TfiAngleDown className="inline-block ml-1" />
      </div>
      <ul className="bg-white hidden group-hover:block absolute z-10 mt-0 pt-0 -translate-x-3 p-3">
        {data.subItems.map((value) => (
          <Link
            className="hover:text-pink mt-4 mb-2 block"
            key={value.id}
            to={value.url}
          >
            {value.text}
          </Link>
        ))}
      </ul>
    </div>
  ) : (
    <Link key={data.id} to={data.url} className="mr-6 hover:text-pink">
      {data.text}
    </Link>
  );
}
